<template>
  <v-main>
    <Sidebar :is-open.sync="isOpen"></Sidebar>
    <v-app-bar app>
      <v-app-bar-nav-icon
        v-show="$vuetify.breakpoint.smAndDown"
        @click="isOpen = !isOpen"
      ></v-app-bar-nav-icon>
      <router-link
        class="ml-n6"
        :to="{ name: 'Home' }"
        v-if="$store.getters.user.user_category !== 4"
      >
        <v-img
          src="@/assets/clickLogo.svg"
          alt="RSA Logo"
          aspect-ratio="1"
          title="RSA Logo"
          max-height="40"
          max-width="175"
          class="mx-auto ml-4"
          contain
        ></v-img>
      </router-link>
      <router-link class="ml-n6" :to="{ name: 'PasDashboard' }" v-else>
        <v-img
          src="@/assets/clickLogo.svg"
          alt="RSA Logo"
          aspect-ratio="1"
          title="RSA Logo"
          max-height="40"
          max-width="175"
          class="mx-auto ml-4"
          contain
        ></v-img>
      </router-link>
      <v-spacer></v-spacer>

      <v-btn color="primary" @click="logout()" plain>
        <v-icon>mdi-logout </v-icon>Logout
      </v-btn>
    </v-app-bar>
    <BreadCrumbs></BreadCrumbs>
    <v-row>
      <router-view></router-view>
    </v-row>
  </v-main>
</template>
<script>
import Sidebar from "@/components/front/Sidebar";
import BreadCrumbs from "@/components/front/BreadCrumbs";
import { mapActions, mapMutations } from "vuex";
import { axios } from "@/plugins/http-request.js";

export default {
  components: {
    Sidebar,
    BreadCrumbs,
  },
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    ...mapActions(["snackBar"]),
    ...mapMutations(["setUserToken"]),
    logout() {
      axios.get("/api/logout").then(async () => {
        await this.snackBar({
          color: "success",
          message: "Successfully logged out",
        });
        this.setUserToken("");

        this.$router.go();
        return;
        // If the logout was successful, redirect to the login page
      });
    },
  },
};
</script>
<style>
.v-app-bar {
  z-index: 201 !important;
}
</style>
